import { pluralize } from "@/components/helpers/string-utils";

/**
 * Formats a number of credits as a string with the correct singular or plural form.
 * @param availableCredits - The number of credits to format
 * @returns The formatted string
 */
export function formatCredits(availableCredits?: string | number | null) {
  const amount =
    typeof availableCredits === "string"
      ? parseDecimal(availableCredits || "0.00")
      : availableCredits || 0;

  return pluralize({
    amount: Math.max(0, amount),
    singular: "Credit",
    plural: "Credits",
    showCount: true,
  });
}

/**
 * Formats a number of credits as a string with the correct singular or plural form in lowercase.
 * @param availableCredits - The number of credits to format
 * @returns The formatted string
 */
export function formatCreditsLowerCase(
  availableCredits?: string | number | null,
) {
  return formatCredits(availableCredits).toLowerCase();
}

/**
 * Parses a string that was converted from a Django Decimal.
 * @param input - The string to parse
 * @returns The parsed number
 */
export function parseDecimal(input?: string | null): number {
  return parseFloat(input ?? "0.00");
}
